// extracted by mini-css-extract-plugin
export default {"container":"winter-tires-banner__container___12XA6","cta":"winter-tires-banner__cta___1PWXz","img":"winter-tires-banner__img___3jJQ1"};